<!--
 * @Author: 汪满青
 * @Date: 2025-01-07 16:30:06
 * @LastEditors: zouxin
 * @LastEditTime: 2025-02-18 10:34:00
 * @Description: 预览模版
 -->
 <template>
  <div class="dialogContent">
    <div class="leftContent">
      <div v-show="previewDetailData.itemStatus === 3" class="headerTitle">
        <span class="redColor">{{$t('project.reviewNotPassedReason')}}：</span>
        {{ previewDetailData.reviewRemark }}
      </div>
      <img style="width:1243px;height:699px;" :src="previewDetailData.coverUrl" alt="" />
    </div>
    <div class="rightContent">
      <div class="headerTitle fontSizeTitle">
        {{ previewDetailData.name}}
      </div>
      <div class="projectItem" :style="{ width: '100%' }">
        <div class="detailsItem">
          <div class="projectItemTitle">{{$t('project.details')}}</div>
          <div class="detailsContent">
            <div class="detailsFlex">
              <div class="leftWidth">{{$t('project.size')}}：</div>
              {{ previewDetailData.size || 0 }}M
            </div>
            <div class="detailsFlex">
              <div class="leftWidth">{{$t('project.industry')}}：</div>
              {{ previewDetailData.industry }}
            </div>
            <div class="detailsFlex">
              <div class="leftWidth">{{$t('project.uploadTime')}}：</div>
              {{ previewDetailData.publishTime && previewDetailData.publishTime.substring(0, 10) }}
            </div>
          </div>
        </div>
        <a-divider />
        <div class="produceItem">
          <div class="projectItemTitle">{{$t('project.introduction')}}</div>
          <div class="produceContent">{{previewDetailData.remark || '暂无简介'}}</div>
        </div>
        <a-divider />
        <div class="creatorItem">
          <div class="projectItemTitle">{{$t('project.creator')}}</div>
          <div class="creatorContent">{{previewDetailData.supplierName}}</div>
        </div>

        <template>
          <a-divider />
          <div class="versionItem">
            <div class="projectItemTitle">{{$t('project.version')}}</div>
            <div class="versionDetails">
              V{{ previewDetailData.version }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import dialogContentImg from '@/assets/images/empty-data.png'
import { getProjectDetail, getTemplateDetailById } from '@/api/myTemplate'

export default {
  name: 'PreviewTemplate',
  props: {
    previewData: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: undefined,
      previewDetailData: {},
      industryOptions: JSON.parse(localStorage.getItem('getIndustryList') || '[]')
    }
  },
  computed: {
    imgHost() {
      if(this.previewDetailData.coverUrl?.indexOf('http') > -1){
        return ''
      }
      return process.env.VUE_APP_CTYUN_URL
    }
  },
  mounted() {
    if(this.type === 'project'){
      this.getDetail()
    } else if(this.type === 'template' || this.type === 'download'){
      this.templateDetail()
    }
  },
  methods: {
    handleChangeVersion(versionValue) {
      this.templateDetail(versionValue)
    },
    // 获取项目详情
    async getDetail() {
      try {
        const res = await getProjectDetail({ projectId: this.previewData.id })
        console.log('获取的项目详情', res)
        if (res.code === 200) {
          this.previewDetailData = {
            ...res.data,
            name: res.data.projectName,
            coverUrl: res.data.coverPath || dialogContentImg,
            publishTime: res.data.updateTime,
            supplierName: res.data.account,
            remark: res.data.description
          }
          this.value = +res.data.version
        }
      } catch (error) {
        console.error('获取项目详情失败:', error)
      }
    },
    // 获取模板详情
    async templateDetail(versionValue) {
      try {
        const res = await getTemplateDetailById({ 
          id: this.previewData.id
        })
        console.log('获取的沙盘模版详情', res)
        if (res.status === 0) {
          this.previewDetailData = res.data
          this.previewDetailData.coverUrl = res.data.coverUrl ? 
            (this.imgHost + res.data.coverUrl) : dialogContentImg
          
          this.industryOptions.forEach((item) => {
            if (item.value === res.data.industry) {
              this.previewDetailData.industry = item.name
            }
          })
        }
      } catch (error) {
        console.error('获取模板详情失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.redColor {
  color: red;
}

.fontSizeTitle {
  font-size: 20px;
}

.dialogContent {
  display: flex;
  width: 100%;
  .headerTitle {
    margin-bottom: 15px;
  }

  .leftContent {
    flex: 4;
  }

  .rightContent {
    flex: 1;
    margin-left: 24px;

    .detailsContent {
      margin: 10px 0 16px;
    }

    .produceContent {
      max-height: 120px;
      overflow: auto;
      margin: 10px 0 16px;
      color:#D3D3D3;
    }

    .creatorContent {
      margin: 10px 0 16px;
    }

    .versionDetails {
      margin: 10px 0 0 0;
    }

    .detailsFlex {
      display: flex;
      margin-top: 12px;
    }

    .leftWidth {
      width: 100px;
      color: #D3D3D3;
    }
  }
}

.projectItem {
  .projectItemTitle {
    font-size: 18px;
  }
}

.read-the-docs {
  color: #888;
}
</style>